<ion-header>
  <ion-toolbar color="danger">
    <ion-buttons slot="start">
      <ion-button (click)="goUserProfile()">
        <ion-icon class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'USER.delete.title' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <div class="content-div ion-margin ion-padding-vertical">
    <ion-icon class="icon-warning center ion-margin" src="./assets/wedding/img/general/sad.svg"></ion-icon>
    <div class="font-bold ion-text-center ion-padding-vertical">
      {{ 'USER.delete.intro' | translate }}
    </div>
    <div>
      <ul class="font-12">
        <li class="ion-margin-vertical">{{ 'USER.delete.msg.note.1' | translate }}</li>
        <li class="ion-margin-vertical">{{ 'USER.delete.msg.note.2' | translate }}</li>
        <li class="ion-margin-vertical">{{ 'USER.delete.msg.note.3' | translate }}</li>
        <ng-container *ngIf="ownAccountList?.length">
          <li class="ion-margin-vertical"><ion-text color="danger" [innerHTML]="'USER.delete.msg.note.4' | translate"></ion-text></li>
        </ng-container>
      </ul>
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <div class="content-div">
      <ion-button class="ion-margin" expand="block" color="danger" (click)="confirmDeleteUserAccount()">
        {{ 'USER.delete.btn' | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
